<template>
  <div id="loadingCover">
    <!-- <div class='base' v-show='loadingCover'>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
   <div class='cube'></div>
 </div> -->
    <transition name="slide">
      <div class="load_cover_box" @touchmove.prevent v-if="loadingCover == 1">
        <!--  -->
        <!-- <div class="l_h_header">
        <p></p>
        <p></p>
        <p></p>
      </div> -->
        <div class="l_c_top"></div>
        <div class="l_c_div">
          <ul class="l_c_nav">
            <li
              v-for="(item, index) in 5"
              :key="index"
              :class="['nav_' + index, 'nav_all']"
            ></li>
          </ul>
          <p class="living_title"></p>
          <ul class="l_c_m1">
            <li v-for="(item, index) in 4" :key="index"></li>
          </ul>
          <div class="head_line">
            <p class="head_line_left"></p>
            <ul class="l_c_m2">
              <li v-for="(item, index) in 4" :key="index">
                <div>
                  <p></p>
                  <p></p>
                  <p></p>
                </div>
                <div class=""></div>
              </li>
            </ul>
          </div>
          <p class="head_line_bottom_1"></p>
          <p class="head_line_bottom_2"></p>
          <ul class="l_c_m3">
            <li v-for="(item, index) in 4" :key="index">
              <div class=""></div>
              <p></p>
              <p></p>
            </li>
          </ul>
        </div>
      </div>
      <div class="load_cover_box" @touchmove.prevent v-if="loadingCover == 2">
        <div class="l_zone_header">
          <div class="">
            <p></p>
            <p></p>
            <p></p>
          </div>
          <div class=""></div>
        </div>
        <ul class="l_zone_nav">
          <li v-for="(item, index) in 5" :key="index"></li>
        </ul>
        <ul class="l_zone_item">
          <li v-for="(item, index) in 4" :key="index">
            <div class=""></div>
            <div class="">
              <p></p>
              <p></p>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'loadingCover',
  props: {
    coverType: {
      default: 1
    }
  },
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState({
      loadingCover: state => state.loadingCover
    })
  },
  watch: {},
  created() {}
};
</script>

<style lang="less" scoped>
// .slide-enter,
// .slide-leave-active {
//   opacity: 0;
//   -webkit-transform: translate(30px, 0);
//   transform: translate(30px, 0);
// }

.slide-leave-active {
  animation: anim1 1.5s;
}
@keyframes anim1 {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  100% {
    opacity: 0;
    transform: rotate(0.1);
  }
}
.load_cover_box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9999;
  background: #fafafa;
  top: 0;
  font-size: 12px;
  padding: 0rem 0 0.2rem 0;

  .l_h_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.4rem;
    p {
      height: 0.6933rem;
      background: #dedede;
    }
    p:nth-of-type(1) {
      width: 1rem;
      border-radius: 0.1rem;
    }
    p:nth-of-type(2) {
      width: 65%;
    }
    p:nth-of-type(3) {
      width: 0.6933rem;
      border-radius: 50%;
    }
  }

  .l_c_top {
    width: 100%;
    height: 4rem;
    background: #dedede;
    border-radius: 0.1rem;
    // margin-top: .35rem;
  }
  .l_c_div {
    padding: 0 0.4rem;
    .l_c_nav {
      position: relative;
      margin-top: 0.35rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .nav_0 {
        width: 3.53rem;
        height: 2.96rem;
      }
      .nav_1 {
        width: 3.92rem;
        height: 1.39rem;
      }
      .nav_2 {
        width: 1.36rem;
        height: 1.39rem;
      }
      .nav_3 {
        position: absolute;
        bottom: 0%;
        left: 41%;
        width: 2.65rem;
        height: 1.39rem;
      }
      .nav_4 {
        position: absolute;
        bottom: 0%;
        right: 0%;
        width: 2.65rem;
        height: 1.39rem;
      }
      .nav_all {
        background: #dedede;
        border-radius: 0.08rem;
      }
    }
    .living_title {
      margin: 0.3rem auto 0;
      width: 100%;
      height: 0.8rem;
      background: #dedede;
      border-radius: 0.08rem;
    }
    .l_c_m1 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        margin-top: 0.35rem;
        width: 4.53rem;
        height: 2.53rem;
        background: #dedede;
        border-radius: 0.08rem;
      }
    }
    .head_line {
      margin-top: 0.35rem;
      display: flex;
      justify-content: space-between;
      .head_line_left {
        width: 10%;
        height: 8.67rem;
        background: #dedede;
        border-radius: 0.08rem;
      }
      .l_c_m2 {
        width: 80%;
        li {
          margin-top: 0.15rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          div:first-of-type {
            p {
              height: 0.3rem;
            }
            p:nth-of-type(1) {
              width: 3.4rem;
              background: #dedede;
            }
            p:nth-of-type(2) {
              margin: 0.3rem 0;
              width: 2.5rem;
              background: #dedede;
            }
            p:nth-of-type(3) {
              width: 2.5rem;
              background: #dedede;
            }
          }
          div:nth-of-type(2) {
            background: #dedede;
            width: 3.5rem;
            height: 2rem;
            border-radius: 0.2rem;
          }
        }
      }
    }
    .head_line_bottom_1 {
      margin: 0.3rem auto 0;
      width: 40%;
      height: 0.2rem;
      background: #dedede;
      border-radius: 0.08rem;
    }
    .head_line_bottom_2 {
      margin: 0.3rem auto 0;
      width: 30%;
      height: 0.5rem;
      background: #dedede;
      border-radius: 0.08rem;
    }
    .l_c_m3 {
      margin-top: 0.1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      li {
        margin-top: 0.3rem;

        width: 4rem;
        div {
          height: 3rem;
          background: #dedede;
          border-radius: 0.2rem;
        }
        p:nth-of-type(1) {
          width: 80%;
          height: 0.2rem;
          background: #dedede;
          margin: 0.1rem 0;
        }
        p:nth-of-type(2) {
          width: 50%;
          height: 0.2rem;
          background: #dedede;
        }
      }
    }
  }

  .l_zone_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.4rem;

    div:nth-of-type(1) {
      display: flex;

      p {
        height: 0.6933rem;
        background: #dedede;
      }
      p:nth-of-type(1) {
        width: 1rem;
        border-radius: 0.1rem;
      }
      p:nth-of-type(2) {
        width: 2px;
        margin: 0 0.2rem;
      }
      p:nth-of-type(3) {
        width: 1rem;
      }
    }
    div:nth-of-type(2) {
      height: 0.6933rem;
      width: 0.6933rem;
      background: #dedede;
      border-radius: 50%;
    }
  }
  .l_zone_nav {
    display: flex;
    justify-content: space-between;
    padding: 0 0.4rem;
    margin-top: 0.35rem;
    li {
      height: 0.64rem;
      width: 1.5rem;
      background: #dedede;
      border-radius: 0.2rem;
    }
  }
  .l_zone_item {
    padding: 0 0.4rem;
    margin-top: 0.35rem;
    li {
      margin-bottom: 0.3rem;
      div:nth-of-type(1) {
        width: 9.2rem;
        height: 4.4rem;
        border-radius: 0.1rem;
        background: #dedede;
        margin-bottom: 0.1rem;
      }
      div:nth-of-type(2) {
        display: flex;
        justify-content: space-between;
        p {
          height: 0.3rem;
          background: #dedede;
          border-radius: 0.1rem;
        }
        p:nth-of-type(1) {
          width: 3rem;
        }
        p:nth-of-type(2) {
          width: 1.5rem;
        }
      }
    }
  }
}
</style>
<style scoped>
/*
loading*/
/* .base {
  height: 5rem;
  left: 50%;
  margin: -7.5em;
  padding: 3em;
  position: absolute;
  top: 5rem;
  width: 5rem;
  transform: rotateX(45deg) rotateZ(45deg);
  transform-style: preserve-3d;
  z-index: 99999;
}

.cube,
.cube:after,
.cube:before {
  content: '';
  float: left;
  height: 3em;
  position: absolute;
  width: 3em;
}



.cube {
  background-color: #05afd1;
  position: relative;
  transform: translateZ(3em);
  transform-style: preserve-3d;
  transition: .25s;
  box-shadow: 13em 13em 1.5em rgba(0, 0, 0, 0.1);
  animation: anim 1s infinite;
}

.cube:after {
  background-color: #049dbc;
  transform: rotateX(-90deg) translateY(3em);
  transform-origin: 100% 100%;
}

.cube:before {
  background-color: #048ca7;
  transform: rotateY(90deg) translateX(3em);
  transform-origin: 100% 0;
}

.cube:nth-child(1) {
  animation-delay: 0.05s;
}

.cube:nth-child(2) {
  animation-delay: 0.1s;
}

.cube:nth-child(3) {
  animation-delay: 0.15s;
}

.cube:nth-child(4) {
  animation-delay: 0.2s;
}

.cube:nth-child(5) {
  animation-delay: 0.25s;
}

.cube:nth-child(6) {
  animation-delay: 0.3s;
}

.cube:nth-child(7) {
  animation-delay: 0.35s;
}

.cube:nth-child(8) {
  animation-delay: 0.4s;
}

.cube:nth-child(9) {
  animation-delay: 0.45s;
}

@keyframes anim {
  50% {
    transform: translateZ(0.5em);
  }
} */
</style>
